/**
 * StatusModal — Auto-dismiss error/status popup.
 */

import React from "react";

const StatusModal = ({ message, visible, onClose }) => {
  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/30 cursor-pointer"
      onClick={onClose}
    >
      <div className="flex items-start justify-center pt-32 px-4">
        <div
          className="px-6 py-4 bg-white rounded-2xl shadow-xl max-w-md"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="text-sm text-gray-700">{message}</p>
        </div>
      </div>
    </div>
  );
};

export { StatusModal };
